import { Link } from "@/components/common/Link";
const navLinks = [{
  label: "Private Dining",
  href: "/PrivateDiningPage"
}, {
  label: "Bamboo Hall",
  href: "/BambooHallPage"
}, {
  label: "Workshop Space",
  href: "/WorkshopSpacePage"
}];
const socialLinks = [{
  label: "Instagram",
  href: "#"
}, {
  label: "WhatsApp",
  href: "#"
}, {
  label: "Journal",
  href: "/JournalPage"
}];
const legalLinks = [{
  label: "Terms & Conditions",
  href: "#"
}, {
  label: "Privacy Policy",
  href: "#"
}, {
  label: "Contact Us",
  href: "/ConnectPage"
}];
export default function Footer() {
  return <footer data-section-id="159848" id="footer" className="dark bg-background text-foreground border-t border-primary/20 py-16 px-6 md:px-12 text-[12px] font-sans uppercase tracking-widest">
      <div className="mx-auto max-w-7xl grid grid-cols-1 gap-12 md:grid-cols-4 md:gap-8">
        {}
        <div className="flex flex-col items-start space-y-6">
          <Link to="/HomePage" className="inline-block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/jojis_preloved_logo_light.png" alt="Logo" className="h-7 w-auto object-contain" />
          </Link>
          <p className="text-muted-foreground leading-relaxed max-w-[250px] lowercase first-letter:uppercase tracking-normal font-light">
            Premium event venue in Peliatan, Ubud. Hosting intimate private dining, bamboo hall weddings, and creative workshops.
          </p>
        </div>

        {}
        <div className="flex flex-col space-y-4">
          <h3 className="text-primary mb-2 font-bold tracking-widest">Explore</h3>
          <ul className="flex flex-col space-y-3">
            {navLinks.map((link, i) => <li key={link.label} data-index={i}>
                <Link to={link.href} className="hover:text-secondary transition-colors duration-300">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        {}
        <div className="flex flex-col space-y-4">
          <h3 className="text-primary mb-2 font-bold tracking-widest">Connect</h3>
          <ul className="flex flex-col space-y-3">
            {socialLinks.map((link, i) => <li key={link.label} data-index={i}>
                <Link to={link.href} newTab={link.label !== "Journal"} className="hover:text-secondary transition-colors duration-300">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        {}
        <div className="flex flex-col space-y-4">
          <h3 className="text-primary mb-2 font-bold tracking-widest">Legal</h3>
          <ul className="flex flex-col space-y-3">
            {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                <Link to={link.href} className="hover:text-secondary transition-colors duration-300">
                  {link.label}
                </Link>
              </li>)}
            <li data-index={legalLinks.length} className="pt-4 text-muted-foreground/40 text-[10px]">
              &copy; {new Date().getFullYear()} Ubud Event Space
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}